'use client';
import React, { Suspense } from 'react';
import { showCornerStone } from '@benzinga/navigation-ui';
import { MoneyTemplateProps } from '../../entities';
import { MoneyPostLayout } from '../MoneyPostLayout';
import { Tabs, EdgeBadge } from '@benzinga/core-ui';
import { useCustomRouter } from '@benzinga/hooks';
import { usePathname } from 'next/navigation';
import { PageCampaigns } from '../Campaign/PageCampaigns';
import styles from './MoneyPageTemplate.module.css';

export const MoneyPageTemplate: React.FC<MoneyTemplateProps> = ({
  layoutAboveArticle,
  layoutAboveSidebar,
  layoutBelowArticle,
  layoutFooter,
  layoutHeader,
  layoutTabs,
  layoutTabsOptions = {},
  post,
  tabOptions = {},
  tabsTitle,
  width,
}) => {
  const router = useCustomRouter();
  const pathname = usePathname();

  React.useEffect(() => {
    if (Array.isArray(layoutTabs)) {
      if (layoutTabsOptions?.prefetchAllTabs) {
        layoutTabs
          .filter(tab => tab.key !== pathname)
          .forEach(tab => {
            router.prefetch(tab.key);
          });
      } else if (Array.isArray(layoutTabsOptions?.prefetchTabs)) {
        layoutTabsOptions.prefetchTabs
          .filter(tab => tab !== pathname)
          .forEach(tab => {
            router.prefetch(tab);
          });
      }
    }
  }, [layoutTabs, router, layoutTabsOptions, pathname]);

  // TODO: PROBABLY A BETTER WAY TO DO THIS
  const pageType = post?.taxonomies?.find(
    object => object.taxonomy === 'page-type' && object.term?.slug === 'full-width',
  )?.term?.slug;
  const pageWidth = width || showCornerStone(post ?? null) || pageType === 'full-width' ? 'wide' : 'narrow';

  const onChangeTab = (key: string) => {
    window.location.href = key;
    //router.replace(key);
  };

  return (
    <div className={`${styles.wrapper} money-page-template ${pageWidth}`}>
      {layoutTabs && (
        <div className={`w-full flex items-center justify-center px-2 ${styles.tabHeader}`}>
          <div className="layout-container max-w-[1400px] w-full">
            {tabsTitle && (
              <div className="flex items-center gap-8 mb-4">
                <div className="scale-150 ml-5">{EdgeBadge}</div>
                <h2 className="text-3xl uppercase">{tabsTitle}</h2>
              </div>
            )}
            <Tabs
              activeTab={pathname as string}
              isShowMoreButtonEnabled={false}
              onChange={onChangeTab}
              tabBarGutter={10}
              tabs={layoutTabs}
              variant="lifted"
              {...tabOptions}
            />
          </div>
        </div>
      )}
      {layoutHeader}
      <MoneyPostLayout
        layoutAboveArticle={layoutAboveArticle}
        layoutAboveSidebar={layoutAboveSidebar}
        layoutBelowArticle={layoutBelowArticle}
        maxWidth={pageWidth === 'wide' ? '1400px' : '1100px'}
        post={post ?? null}
      />
      {layoutFooter && (
        <div className="layout-footer primary">
          <div className="layout-container mx-auto">{layoutFooter}</div>
        </div>
      )}
      <Suspense fallback={<div />}>
        <PageCampaigns post={post} />
      </Suspense>
    </div>
  );
};

export default MoneyPageTemplate;
